import React, { useState } from "react";

const DropDown = ({ dropdowns }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (index) => {
    console.log("Toggling dropdown:", index);
    setOpenDropdown(openDropdown === index ? null : index);
  };

  return (
    <div className="border-end border-start border-top rounded">
      {dropdowns.map((dropdown, index) => (
        <div key={index}>
          <div
            className={`border-bottom d-flex align-items-center ${
              dropdown.icon ? "p-2" : "p-3"
            }`}
            style={{ backgroundColor: "#fafafa" }}
          >
            <div className={`${dropdown.icon ? "col-lg-11" : "col-lg-12"}`}>
              <p
                className="d-block m-0"
                onClick={() => toggleDropdown(index)}
                style={{ color: "rgb(42, 68, 124)", cursor: "pointer" }}
              >
                <i
                  className={`bi ${
                    openDropdown === index
                      ? "bi-chevron-down"
                      : "bi-chevron-right"
                  }`}
                  style={{
                    marginRight: "0.5rem",
                    verticalAlign: "middle",
                    transition: "transform 1s ease-in-out",
                    transform: `rotate(${
                      openDropdown === index ? "90deg" : "0deg"
                    })`,
                  }}
                ></i>{" "}
                {dropdown.title}
              </p>
            </div>
            {dropdown.icon && (
              <div className="col-lg-1 text-center">{dropdown.icon}</div>
            )}
          </div>

          {openDropdown === index && (
            <div
              className="content bg-white  text-dark p-3 border-bottom"
              style={{
                height: openDropdown === index ? "auto" : "0",
                overflow: "hidden",
                transition: "height 4s ease-in-out",
              }}
            >
              {dropdown.content}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DropDown;
